import { createAction } from 'typesafe-actions';

export type Language = string;

export const setLanguage = createAction('@bs/SET_LANGUAGE')<Language>();
